import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core'
import { AuthService } from '../services/auth'

export const authGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const loggedIn = await authService.isAuthenticated();
    if (loggedIn) {
        return true;
    } else {
        router.navigate(['/login']);
        return false;
    }
};
